export default "__VITE_ASSET__DBZCS26C__"